/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_SavedInputs */

const en_ai_saved = /** @type {(inputs: Ai_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saved.`)
};

const de_ai_saved = /** @type {(inputs: Ai_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gespeichert.`)
};

/**
* | output |
* | --- |
* | "Saved." |
*
* @param {Ai_SavedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ai_saved = /** @type {((inputs?: Ai_SavedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_SavedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ai_saved(inputs)
	return en_ai_saved(inputs)
});